import { S3_BUCKET_URL } from 'constants/constants';

export const refactorImgUrl = (url: string) => {
  return `${S3_BUCKET_URL}${url}`;
};
